import { useI18n } from "../../../i18n/i18n";
import { isCreatableMarkerOption, isSelectAllMarkerOption } from "../utils";

export const useMultiSelectOptionToString = <Option>(
    optionToString: (option: Option) => string,
    inputValue: string
): ((option: Option | null) => string) => {
    const { i18n } = useI18n();

    return (option: Option | null) => {
        if (option === null) {
            // This is a downshift-ism that we'll hide from our consumers.
            // This doesn't really apply in the multiselect case but this null comes from
            // downshift sharing the same handler for the multiselect and select. The select
            // CAN have a null selection.

            return "";
        } else if (isCreatableMarkerOption(option)) {
            return i18n._(
                /*i18n*/ {
                    comment:
                        "When selected, this component will create a new option with the label 'inputValue' and add it to the list of options",
                    id: `Add "{inputValue}"`,
                    values: { inputValue },
                }
            );
        } else if (isSelectAllMarkerOption(option)) {
            return i18n._(
                /*i18n*/ {
                    comment: "This selects all of the available options in the multi-select",
                    id: `Select All`,
                }
            );
        } else {
            return optionToString(option);
        }
    };
};
